import uploadImage from '../../Actions/uploadImage';
import UploadSingleFile from '../../Actions/uploadSingleFile';
import {AppToast} from '../../HelperClasses/AppToast';
import networkService from '../../Network/NetworkManager';
const APPURL = require('../../Constants/URLConstants');

export const upload_digital_products = async ({listingId, digitalProducts}) => {
  // destructure
  const {title, description, version_name, content, active} =
    digitalProducts || {};

  //
  let digital_file_data = {
    active: active,
  };

  if (!title?.replace(/\s/g, '').length <= 0) {
    digital_file_data['title'] = title;
  }
  if (!description?.replace(/\s/g, '').length <= 0) {
    digital_file_data['description'] = description;
  }

  if (!version_name?.replace(/\s/g, '').length <= 0) {
    digital_file_data['version_name'] = version_name;
  }
  //   if (isVariant) {
  //     digital_file_data.variant_id = variantID;
  //   }

  const uploaded_files =
    content.length > 0
      ? await Promise.all(
          content.map(async item => {
            let file_url = item.file_url ?? '';
            if (item.upload_file) {
              file_url = await UploadSingleFile({
                file: {
                  name: item.file_name,
                  type: item.mime_type,
                  private: true,
                },
                full_file: item.full_file,
              });
            }
            return {
              size: item.size,
              mime_type: item.mime_type,
              file_name: item.file_name,
              file_url: file_url,
            };
          }),
        )
      : [];

  if (uploaded_files?.length > 0) {
    digital_file_data.content = uploaded_files;
  }

  try {
    const res = await networkService.networkCall(
      APPURL.URLPaths.listingsModerate +
        `/${listingId}/digital_contents` +
        (digitalProducts?.id ? `/${digitalProducts?.id}` : ''),
      digitalProducts?.id ? 'PATCH' : 'POST',
      JSON.stringify({digital_content: digital_file_data}),
    );
    if (res) {
      return true;
    }
  } catch (error) {
    AppToast(error.response.data.message);
  }
};
